import { render, staticRenderFns } from "./Low.vue?vue&type=template&id=2a25ea1e&scoped=true"
import script from "./Low.vue?vue&type=script&lang=js"
export * from "./Low.vue?vue&type=script&lang=js"
import style0 from "./Low.vue?vue&type=style&index=0&id=2a25ea1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a25ea1e",
  null
  
)

export default component.exports